import { useEffect, useState } from 'react';
import { useSetError } from '../../redux/modals';
import { awaitJSON, MetricsLambdaFetch } from '../../utils/fetch-utils';
import { ForecastDataTree } from './forecasting-constants';

// Fetches the /getForecastChannels tree for a client once per company. Returns
// `undefined` while loading; consumers render a spinner until it resolves.
export const useForecastChannels = (company: string | undefined): ForecastDataTree | undefined => {
  const setError = useSetError();
  const [dataTree, setDataTree] = useState<ForecastDataTree>();

  useEffect(() => {
    if (!company) return;
    (async () => {
      try {
        const res = await MetricsLambdaFetch('/getForecastChannels', {
          params: { company, testCompanyPageKey: 'FORECASTING' }
        });
        const data = await awaitJSON<{ results?: ForecastDataTree }>(res);
        setDataTree(data.results ?? {});
      } catch (e) {
        setError({ message: e.message, reportError: e });
      }
    })();
  }, [company, setError]);

  return dataTree;
};
